import { EcosystemListingStub } from 'trellis-ecosystem';
import { buildListingUrl } from '../utils/navigation';
import { AutocompleteItem } from './AutocompleteItem';
import { SearchGroupItem } from './SearchGroupItem';
import { jsx as _jsx } from "react/jsx-runtime";
export function SearchOption({
  item,
  onResultSelect,
  searchTerm
}) {
  switch (item.resultType) {
    case 'QUERY':
      return /*#__PURE__*/_jsx(AutocompleteItem, {
        keyword: searchTerm,
        onClick: () => onResultSelect(item),
        queryType: item.queryType,
        suggestion: item.term
      });
    case 'LISTING':
      return /*#__PURE__*/_jsx(EcosystemListingStub, {
        imageSrc: item.iconUrl || '',
        listingHref: buildListingUrl(item.slug),
        name: item.term || '',
        productType: item.productType || 'APP',
        providerName: item.providerName || ''
      });
    case 'CATEGORY':
      return /*#__PURE__*/_jsx(SearchGroupItem, {
        item: item,
        keyword: searchTerm,
        onClick: () => onResultSelect(item)
      });
    case 'COLLECTION':
      return /*#__PURE__*/_jsx(SearchGroupItem, {
        item: item,
        keyword: searchTerm,
        onClick: () => onResultSelect(item)
      });
    default:
      return null;
  }
}